import React from 'react';

interface LogoProps {
  variant?: 'default' | 'light';
  className?: string;
}

const Logo: React.FC<LogoProps> = ({ variant = 'default', className = '' }) => {
  const logoSrc = variant === 'light' ? '/logo-smata-light.png' : '/logo-smata.png';
  return (
    <div className={`flex items-center justify-center mb-8 ${className}`}>
      <img src={logoSrc} alt="Smata Logo" className="h-10 w-auto" />
    </div>
  );
};

export default Logo; 